import { PlatformDependencies } from './platformDependencies';
import { resolveFromGlobal } from './resolveFromGlobal';

/**
 * @category Platform Dependency
 */
export const getLocale = () => resolveFromGlobal(PlatformDependencies.Locale);
